import {createSwiper} from "../../application/utils/swiper";
import {Navigation} from "swiper/modules";

export const TemplateHomeEvents = ( container: HTMLElement ) => {
	const TemplateHomeEventsObject = {
		insightDContainer: container.querySelector( '.loop-slider--insight-d-events' ) as HTMLElement,
		themeRelatedContainer: container.querySelector( '.loop-slider--theme-related-events' ) as HTMLElement,
		_init(): void {
			this._bindClass();
			this._bindEvents();
			this._initSwipers();
		},
		_initSwipers(): void {
			if ( this.insightDContainer ) {
				createSwiper( this.insightDContainer, 'loop-item', {
					"modules": [Navigation],
					allowTouchMove: false,
					autoplay: false,
					breakpoints: {
						0: {
							slidesPerView: 1,
							spaceBetween: 8,
						},
						1024: {
							slidesPerView: 1,
							spaceBetween: 20,
						},
					},
					navigation: {
						nextEl: '.slider__control-button--next',
						prevEl: '.slider__control-button--prev',
					},
					wrapperClass: 'loop-slider__wrapper',
				} );
			}

			if ( this.themeRelatedContainer ) {
				createSwiper( this.themeRelatedContainer, 'loop-item', {
					"modules": [Navigation],
					allowTouchMove: false,
					autoplay: false,
					breakpoints: {
						0: {
							slidesPerView: 1,
							spaceBetween: 8,
						},
						768: {
							slidesPerView: 2,
							spaceBetween: 8,
						},
						1024: {
							slidesPerView: 3,
							spaceBetween: 20,
						},
					},
					navigation: {
						nextEl: '.slider__control-button--next',
						prevEl: '.slider__control-button--prev',
					},
					wrapperClass: 'loop-slider__wrapper',
				} );
			}
		},
		_bindClass(): void {
		},
		_bindEvents(): void {
		},
	}

	TemplateHomeEventsObject._init();
	return TemplateHomeEventsObject;
};
